import axios from "./axiosInstance";

const categoryApi = {
  list: () => axios.post("category"),

  details: (slug) => axios.post(`category-details/${slug}`),
};

export default categoryApi;
